module.exports = __webpack_public_path__ + "img/0xC0888d80EE0AbF84563168b3182650c0AdDEb6d5.fca1e968.png";